(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hb-comentarios-redes"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      if (!root || root.dataset.ready === '1') return;
      root.dataset.ready = '1';
      var viewport = root.querySelector('.hb-sp__viewport');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.hb-sp__card'));
      var prev = root.querySelector('.hb-sp__arrow--prev');
      var next = root.querySelector('.hb-sp__arrow--next');
      var current = root.querySelector('.hb-sp__current');
      var bar = root.querySelector('.hb-sp__bar');
      if (!viewport || !cards.length) return;
      var index = 0, timer = null, touching = false, scrollT = null;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function ui(i) {
        index = Math.max(0, Math.min(i, cards.length - 1));
        if (current) current.textContent = pad(index + 1);
        if (bar) bar.style.width = ((index + 1) / cards.length * 100) + '%';
      }
      function go(i) {
        if (i < 0) i = cards.length - 1;
        if (i >= cards.length) i = 0;
        viewport.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        ui(i);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (reduce || cards.length < 2) return;
        timer = setInterval(function () { if (!touching && !document.hidden) go(index + 1); }, 4800);
      }
      viewport.addEventListener('scroll', function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(function () {
          var left = viewport.scrollLeft + cards[0].offsetLeft, best = 0, dist = Infinity;
          cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft - left); if (d < dist) { dist = d; best = i; } });
          ui(best);
        }, 80);
      }, { passive: true });
      if (next) next.addEventListener('click', function () { stop(); go(index + 1); start(); });
      if (prev) prev.addEventListener('click', function () { stop(); go(index - 1); start(); });
      viewport.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(index + 1); start(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(index - 1); start(); }
      });
      viewport.addEventListener('pointerdown', function () { touching = true; stop(); });
      viewport.addEventListener('pointerup', function () { touching = false; start(); });
      viewport.addEventListener('pointercancel', function () { touching = false; start(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', function () { if (!touching) start(); });
      ui(0);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) start(); else stop(); });
        }, { threshold: 0.2 }).observe(root);
      } else { start(); }
    }
    function initAll() { document.querySelectorAll('[data-hb-sp]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["videos-testimonios"] && !Shopify.designMode) return;
  try {
    (function() {
    function inicializarVideo(tarjeta) {
      var video = tarjeta.querySelector('[data-video]');
      var botonSonido = tarjeta.querySelector('[data-boton-sonido]');

      if (!video) return;

      video.addEventListener('loadedmetadata', function() {
        video.play().catch(function() {});
      });

      if (botonSonido) {
        var iconoMute = botonSonido.querySelector('.videos-testimonios__icono-mute');
        var iconoUnmute = botonSonido.querySelector('.videos-testimonios__icono-unmute');

        botonSonido.addEventListener('click', function() {
          video.muted = !video.muted;

          if (video.muted) {
            if (iconoMute) iconoMute.hidden = false;
            if (iconoUnmute) iconoUnmute.hidden = true;
            botonSonido.setAttribute('aria-label', 'Activar sonido');
          } else {
            if (iconoMute) iconoMute.hidden = true;
            if (iconoUnmute) iconoUnmute.hidden = false;
            botonSonido.setAttribute('aria-label', 'Silenciar');
          }
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entradas) {
          entradas.forEach(function(entrada) {
            if (entrada.isIntersecting) {
              video.play().catch(function() {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.4 });

        observer.observe(video);
      }
    }

    function inicializar() {
      document.querySelectorAll('.seccion-videos-testimonios [data-video-tarjeta]').forEach(function(tarjeta) {
        if (!tarjeta.dataset.inicializado) {
          inicializarVideo(tarjeta);
          tarjeta.dataset.inicializado = 'true';
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inicializar);
    } else {
      inicializar();
    }

    document.addEventListener('shopify:section:load', function(e) {
      e.target.querySelectorAll('.seccion-videos-testimonios [data-video-tarjeta]').forEach(function(tarjeta) {
        if (!tarjeta.dataset.inicializado) {
          inicializarVideo(tarjeta);
          tarjeta.dataset.inicializado = 'true';
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
